// src/pages/LoginPage.jsx
import React from "react";
import Account from "../components/Account";

export default function LoginPage({ theme }) {
  // Provide a full fallback theme for safety
  const safeTheme = theme || {
    colors: {
      background: "#181920",
      text: "#fff",
      logoBackground: "#444",
      logoText: "#fff"
    },
    fontFamily: "inherit",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: safeTheme.colors.background,
        color: safeTheme.colors.text,
        fontFamily: safeTheme.fontFamily,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.2s, color 0.2s",
      }}
    >
      <Account theme={safeTheme} />
    </div>
  );
}
